const config = {
  backendUrl: process.env.REACT_APP_BE_URL || "",
};
export default config;
